module.exports = __webpack_public_path__ + "img/icon_sensor_crop.9e36f34d.gif";